const initCrprgpData = {
  
}


export function crprgpData(
  state = initCrprgpData,
  action
) {
  switch (action.type) {
    case "CRPRGP_FETCH_DATA_SUCCESS":
      return action.dataCrprgp;
    default:
      return state;
  }
}
